<template>
  <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
    <div><br>
      <div class="scroll-container">
      <table>
        <!-- <caption class="table-header">Calderas Eléctricas</caption> -->
        <thead>
          <tr>
            <th class="encabezado columna_sticky" >{{ labels.nombre }}</th>
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_electrica_maxima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_electrica_maxima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_electrica_minima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_electrica_minima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_vapor_maximo }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_vapor_maximo }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.rendimiento_vapor_electricidad }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.rendimiento_vapor_electricidad }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.estado_inicial_equipo }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.estado_inicial_equipo }}</span>
                </v-tooltip>
            </th> 

          </tr>
        </thead>
        <tbody>
          <tr v-for="(caldera, index) in calderas" :key="index" class="tabla-hover">
            <td class="primera_columna columna_sticky">{{ caldera.nombre }}</td>
            <td>
              <input
                type="number"
                v-model.number="caldera.potencia_electrica_maxima"
                @input="emitChanges"
                @change="updateCalculatedFields(index)"
                
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="caldera.potencia_electrica_minima"
                @input="emitChanges"
                
              />
            </td>
            <td class="valor_fijo">
              <input
                type="number"
                :value="caldera.potencia_vapor_maximo"
                disabled
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="caldera.rendimiento_vapor_electricidad"
                @input="emitChanges"
                @change="updateCalculatedFields(index)"
              />
            </td>
            <td>
            <select v-model="caldera.estado_inicial_equipo" @change="emitChanges" :class="{ 'motor_apagado': caldera.estado_inicial_equipo === 'Parado', 'motor_encendido': caldera.estado_inicial_equipo === 'Encendido' }">
                <option value="Parado" class="motor_apagado">Parado</option>
                <option value="Encendido" class="motor_encendido">Encendido</option>
            </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';

const HEADERS_OFICIALES_CALDERAS = [
  "Nombre",
  "Potencia eléctrica máxima",
  "Potencia eléctrica mínima",
  "Potencia vapor máximo",
  "Rendimiento vapor/electricidad",
  "Estado inicial equipo"
];

  export default {
    props: {
      modelValue: {
        type: Array,
        default: () => [], // Array vacío por defecto
      },
    },
    data() {
      return {
        calderas: Array.isArray(this.modelValue) ? [...this.modelValue] : [],
        labels: {
          nombre: this.$t("planta.planta_calderas_electricas"),
          potencia_electrica_maxima: this.$t("planta.calderas_electricas.potencia_electrica_maxima"),
          potencia_electrica_minima: this.$t("planta.calderas_electricas.potencia_electrica_minima"),
          potencia_vapor_maximo: this.$t("planta.calderas_electricas.potencia_vapor_maximo"),
          rendimiento_vapor_electricidad: this.$t("planta.calderas_electricas.rendimiento_vapor_electricidad"),
          estado_inicial_equipo: this.$t("planta.calderas_electricas.estado_inicial_equipo"),
        },
        labels_recortado: {
          nombre: this.$t("planta.planta_calderas_electricas"),
          potencia_electrica_maxima: this.$t("planta.calderas_electricas_corto.potencia_electrica_maxima"),
          potencia_electrica_minima: this.$t("planta.calderas_electricas_corto.potencia_electrica_minima"),
          potencia_vapor_maximo: this.$t("planta.calderas_electricas_corto.potencia_vapor_maximo"),
          rendimiento_vapor_electricidad: this.$t("planta.calderas_electricas_corto.rendimiento_vapor_electricidad"),
          estado_inicial_equipo: this.$t("planta.calderas_electricas_corto.estado_inicial_equipo"),
        },
      };
    },
    watch: {
      modelValue: {
        handler(newValue) {
          this.calderas = Array.isArray(newValue) ? [...newValue] : [];
        },
        deep: true,
      },
      "potencia_vapor_maximo"() {
      this.updateCalculatedFields();
    },
    },
    methods: {
      toCsvDecimalComma(v, fixed = null) {
        if (v === null || v === undefined || v === '') return '';
        const n = Number(v);
        if (Number.isNaN(n)) return '';
        const s = fixed != null ? n.toFixed(fixed) : String(n);
        return s.replace('.', ',');
      },
      emitChanges() {
        this.$emit("update:modelValue", this.calderas);
      },
      updateCalculatedFields(index) {
      const caldera = this.calderas[index];
      if (caldera) {
        caldera.potencia_vapor_maximo = parseFloat((caldera.potencia_electrica_maxima * caldera.rendimiento_vapor_electricidad) || 0).toFixed(2);
        this.emitChanges();
      }
    },
    exportToCSV() {
  try {
    const headers = HEADERS_OFICIALES_CALDERAS;

    const rows = this.calderas.map(c => [
      c.nombre ?? '',
      this.toCsvDecimalComma(c.potencia_electrica_maxima),
      this.toCsvDecimalComma(c.potencia_electrica_minima),
      this.toCsvDecimalComma(c.potencia_vapor_maximo), 
      this.toCsvDecimalComma(c.rendimiento_vapor_electricidad),
      (c.estado_inicial_equipo === 'Encendido' || c.estado_inicial_equipo === 'Parado') ? c.estado_inicial_equipo : ''
    ].join(';'));

    const csvContent = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "calderas_electricas.csv";
    link.click();
    URL.revokeObjectURL(link.href);

    Swal.fire({ icon: 'success', title: 'Exportación correcta', timer: 1600, showConfirmButton: false });
  } catch (e) {
    Swal.fire({ icon: 'error', title: 'Error al exportar', text: e?.message || 'Revisa los datos.' });
  }
},


    importFromCSV() {
      this.$refs.fileInput.click();
    },
    parseNumber(value) {
      if (!value) return 0;

      
      value = value.trim();

      
      if (value.includes(',') && !value.includes('.')) {
        value = value.replace(/\./g, '');        
        value = value.replace(',', '.');          
      }

      
      else if (value.includes(',') && value.includes('.')) {
        
        if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
          value = value.replace(/\./g, '');       
          value = value.replace(',', '.');      
        }
        
        else {
          value = value.replace(/,/g, '');        
        }
      }

      

      return parseFloat(value);
    },
handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = content.replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      
// ====== Validación de CABECERAS  ======
let headers = lines[0]
  .split(';')
  .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

// 1) faltantes / extras
const faltantes = HEADERS_OFICIALES_CALDERAS.filter(h => !headers.includes(h));
const extrasRaw = headers.filter(h => !HEADERS_OFICIALES_CALDERAS.includes(h));

//  limpiar valores vacíos/espacios 
const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

// 2) desordenadas solo si no hay faltantes ni extras visibles
let desordenadas = [];
if (faltantes.length === 0 && extras.length === 0) {
  HEADERS_OFICIALES_CALDERAS.forEach((h, i) => {
    if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
  });
}

// 3) renderizar solo secciones con elementos 
const seccion = (titulo, arr) => {
  const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
  return items.length
    ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
       <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
    : '';
};

if (faltantes.length || extras.length || desordenadas.length) {
  const html =
    `<div style="text-align:left;">
       <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
       ${seccion('❌ Faltan', faltantes)}
       ${seccion('⚠️ Sobran', extras)}
       ${seccion('🔄 Desordenadas', desordenadas)}
       <p style="margin-top:6px;"><small>
         Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
       </small></p>
     </div>`;
  Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
  event.target.value = '';
  return;
}
// ====== Fin validación de CABECERAS ======

      // Índices 
      const IDX = {
        nombre: 0,
        pElecMax: 1,                         // Potencia eléctrica máxima
        pElecMin: 2,                         // Potencia eléctrica mínima
        pVaporMax: 3,                        // Potencia vapor máximo 
        rendimiento: 4,                      // Rendimiento vapor/gas
        estado: 5                            // Estado inicial equipo
      };

      
      const faltasPorCol = {
        [headers[IDX.nombre]]: [],
        [headers[IDX.pElecMax]]: [],
        [headers[IDX.pElecMin]]: [],
        [headers[IDX.pVaporMax]]: [],
        [headers[IDX.rendimiento]]: [],
        [headers[IDX.estado]]: [],
      };
      const negativosPorCol = {
        [headers[IDX.pElecMax]]: [],
        [headers[IDX.pElecMin]]: [],
        [headers[IDX.pVaporMax]]: [],
        [headers[IDX.rendimiento]]: [],
      };

      const nuevos = [];
      let erroresCoherencia = []; // min>max o vapor!=calc

      
      const raw = (arr, i) => String(arr[i] ?? '').trim();

      // Valida y parsea número (no acepta vacío)
      const parseNumberStrict = (value) => {
        const s = String(value ?? '').trim();
        if (s === '') return { ok: false, num: NaN };
        
        const n = this.parseNumber(s);
        return { ok: Number.isFinite(n), num: n };
      };

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.every(c => c.trim() === '')) continue;
        if (cols.length !== HEADERS_OFICIALES_CALDERAS.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }

        const row = i + 1;

        const nombre = raw(cols, IDX.nombre);
        const pElecMaxRaw = raw(cols, IDX.pElecMax);
        const pElecMinRaw = raw(cols, IDX.pElecMin);
        const pVaporMaxRaw = raw(cols, IDX.pVaporMax);
        const rendimientoRaw = raw(cols, IDX.rendimiento);
        const estado = raw(cols, IDX.estado);

        // Requeridos vacíos
        if (!nombre) faltasPorCol[headers[IDX.nombre]].push(row);
        if (!pElecMaxRaw) faltasPorCol[headers[IDX.pElecMax]].push(row);
        if (!pElecMinRaw) faltasPorCol[headers[IDX.pElecMin]].push(row);
        if (!pVaporMaxRaw) faltasPorCol[headers[IDX.pVaporMax]].push(row);
        if (!rendimientoRaw) faltasPorCol[headers[IDX.rendimiento]].push(row);
        if (!estado) faltasPorCol[headers[IDX.estado]].push(row);

        
        const { ok: okMax, num: pElecMax } = parseNumberStrict(pElecMaxRaw);
        const { ok: okMin, num: pElecMin } = parseNumberStrict(pElecMinRaw);
        const { ok: okRend, num: rendimiento } = parseNumberStrict(rendimientoRaw);
        const { ok: okVap, num: pVaporMaxCsv } = parseNumberStrict(pVaporMaxRaw);

        // Numéricos inválidos
        if (pElecMaxRaw && !okMax) faltasPorCol[headers[IDX.pElecMax]].push(row);
        if (pElecMinRaw && !okMin) faltasPorCol[headers[IDX.pElecMin]].push(row);
        if (rendimientoRaw && !okRend) faltasPorCol[headers[IDX.rendimiento]].push(row);
        if (pVaporMaxRaw && !okVap) faltasPorCol[headers[IDX.pVaporMax]].push(row);

        // Negativos no permitidos
        if (okMax && pElecMax < 0) negativosPorCol[headers[IDX.pElecMax]].push(row);
        if (okMin && pElecMin < 0) negativosPorCol[headers[IDX.pElecMin]].push(row);
        if (okRend && rendimiento < 0) negativosPorCol[headers[IDX.rendimiento]].push(row);
        if (okVap && pVaporMaxCsv < 0) negativosPorCol[headers[IDX.pVaporMax]].push(row);

        // Coherencia min<=max 
        if (okMax && okMin && pElecMin > pElecMax) {
          erroresCoherencia.push(`Fila ${row}: 'Potencia eléctrica mínima' no puede superar a 'Potencia eléctrica máxima'.`);
        }

        // Estado válido
        if (estado && estado !== 'Encendido' && estado !== 'Parado') {
          erroresCoherencia.push(`Fila ${row}: 'Estado inicial equipo' debe ser 'Encendido' o 'Parado'.`);
        }

        // Coherencia vapor = max * rendimiento 
        if (okMax && okRend && okVap) {
          const pVaporMaxCalc = Number((pElecMax * rendimiento).toFixed(2));
          if (Math.abs(pVaporMaxCsv - pVaporMaxCalc) > 0.01) {
            erroresCoherencia.push(
              `Fila ${row}: 'Potencia vapor máximo' debe ser 'Potencia eléctrica máxima' × 'Rendimiento vapor/gas'. Valor esperado: ${pVaporMaxCalc}.`
            );
          }
        }

        // Solo añadimos si TODA la fila está correcta

        nuevos.push({
          nombre,
          potencia_electrica_maxima: okMax ? pElecMax : null,
          potencia_electrica_minima: okMin ? pElecMin : null,
          potencia_vapor_maximo: okMax && okRend ? Number((pElecMax * rendimiento).toFixed(2)) : null,
          rendimiento_vapor_electricidad: okRend ? rendimiento : null,
          estado_inicial_equipo: estado || null
        });
      }

      // Agrega y muestra errores
      const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
      const columnasConNegativos = Object.entries(negativosPorCol).filter(([, arr]) => arr.length);

      if (columnasConFaltas.length || columnasConNegativos.length || erroresCoherencia.length) {
        const bloques = [];

        if (columnasConFaltas.length) {
          const htmlFaltas = columnasConFaltas.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Faltan datos obligatorios</h4>${htmlFaltas}`);
        }

        if (columnasConNegativos.length) {
          const htmlNe = columnasConNegativos.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Valores negativos no permitidos</h4>${htmlNe}`);
        }

        if (erroresCoherencia.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Inconsistencias</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${erroresCoherencia.map(m => `<li>${m}</li>`).join('')}</ul>`
          );
        }

        Swal.fire({
          icon: 'error',
          title: 'Errores en datos',
          html: `<div style="text-align:left; max-height:50vh; overflow:auto;">${bloques.join('<br>')}</div>`,
          width: 820
        });
        event.target.value = '';
        return; // bloquea importación
      }

      // Si todo correcto
      const definitivos = nuevos.map(n => ({
        nombre: n.nombre,
        potencia_electrica_maxima: n.potencia_electrica_maxima,
        potencia_electrica_minima: n.potencia_electrica_minima,
        potencia_vapor_maximo: n.potencia_vapor_maximo,
        rendimiento_vapor_electricidad: n.rendimiento_vapor_electricidad,
        estado_inicial_equipo: n.estado_inicial_equipo
      }));

      this.calderas = definitivos;
      this.emitChanges();
      Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${definitivos.length} registros importados.` });

    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; 
    }
  };

  reader.readAsText(file, 'utf-8');
},

    },
  };
  </script>
  
  <style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
    /* Contenedor con scroll horizontal y vertical */
    .scroll-container {
    width: 100%;
    max-height: 500px; /* Altura máxima antes de que aparezca el scroll vertical */
    overflow-x: auto;
    overflow-y: auto;
    border-radius: 10px;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  
  .primera_columna{
    background-color: white;
  }
  .valor_fijo{
    background-color: white;
  }



  
  select {
    width: 100%;
    border: 1px solid #F2F2F2;
    border-radius: 4px;
    text-align: center;
    color: #024e74;
  }
  

  </style>
  